import { Capacitor } from '@capacitor/core';
// Explicit local preview only. Production browser bundles always keep web behavior.
export const isMobileApp = () => process.env.REACT_APP_BUILD_TARGET === 'native' || Capacitor.isNativePlatform() || (process.env.NODE_ENV === 'development' && process.env.REACT_APP_NATIVE_PREVIEW === 'true');

